<template>
  <div>
    <Loading :show="loading" />
    <router-view @reload="fetch(true)"></router-view>

    <div v-if="!archivedOrders.length && !loading" class="no-orders">
      <p>Hittade inga tidigare resor.</p>
    </div>

    <div v-if="archivedOrders.length" class="booking-group">
      <h2>Tidigare resor</h2>
      <table :class="{disabled: loading}">
        <thead>
          <tr>
            <th>Bokningsnummer</th>
            <th class="center">Ankomst</th>
            <th class="right">Summa</th>
            <!--<th class="right">Återstår</th>-->
            <th class="center">Information</th>
          </tr>
        </thead>
        <tbody v-for="orders in archivedOrders">
          <tr>
            <th colspan="4" style="background-color:white;text-align:left;">
              <h3 style="margin-bottom:0;margin-top: 1em;margin-left: 10px;">{{orders[0].season}}</h3>
            </th>
          </tr>
          <tr v-for="order in orders" class="table-row">
            <td>
              <span class="mobile-title">Bokningsnr</span>
              {{order.resvid}}
            </td>
            <td class="center">
              <span class="mobile-title">Ankomst</span>
              {{order.arrivaldate.substr(0, 10)}}
            </td>
            <td class="right">
              <span class="mobile-title">Summa</span>
              <b>{{order.sum | currency}}</b>
            </td>
            <!--<td class="right"><b>{{order.topay | currency}}</b></td>-->
            <td class="center wide">
              <button class="white border small" @click="goToBooking(order.headlid)"><icon name="info-blue" :scale="1.3" /> Visa bokning</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import Loading from '@/components/components/Loading';
import PrettyOrder from '@/components/components/PrettyOrder';

export default {
  data() {
    return {
      orders: {
        active: [],
        upcoming: [],
        archived: [],
      },
      user: {},
      loading: false,
    };
  },
  components: {
    Loading,
    PrettyOrder,
  },
  computed: {
    activeOrders() {
      return this.orders.active;
    },
    upcomingOrders() {
      return this.orders.upcoming;
    },
    archivedOrders() {
      return this.orders.archived;
    },
  },
  methods: {
    async fetch(hideLoading) {
      if (!hideLoading) {
        this.loading = true;
      }
      const { user } = await API.get('/account/user');
      if (user) {
        this.user = user;
        const { data } = await API.get('/orders/archived');
        this.orders = data;
      }
      if (!hideLoading) {
        this.loading = false;
      }
    },
    goToBooking(no) {
      const currentUri = encodeURI(this.$route.path);
      this.$router.push(`/mina-sidor/bokningar/${no}?flow=${currentUri}`);
      // this.$router.push({ name: 'my booking', params: { bookingNumber: no } });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.right
  float none

table
  width 100%
  thead
    th
      background-color: var(--booking-color-primary);
      color white
      padding 10px
      font-size: 15px;
  tr
    &:nth-child(odd)
      background-color: #f9f9f9;
    &:nth-child(even)
      background-color: white;
  td
    padding-top 10px
    padding-bottom 10px
    padding-right 10px
    padding-left 10px
    font-size: 14px;
    font-weight: 300;
  .right
    text-align right
  .center
    text-align center

.disabled
  disabled-grey()

.mobile-title
  display none
+max-mobile()
  .mobile-title
    display block
    font-weight: 700
  thead
    display none
  tbody
    display block
    .table-row
      display: flex
      flex-wrap: wrap
      width 100%
      td
        display inline-block
        width 33%
        &.wide
          width 100%
          button
            width 100%
            max-width 300px

+max-screen(400px)
  tbody
    .table-row
      td
        width 50%
        text-align: left !important

.booking-group
  padding-bottom: 40px
  padding-top: 40px
  // border-bottom: 1px solid #e0e0e0
  & > h2
    margin-bottom: 16px

.no-orders
  margin 3rem auto
  text-align: center
</style>



// WEBPACK FOOTER //
// MyPageBookings.vue?442aac17